import { render, staticRenderFns } from "./ManagedListCard.vue?vue&type=template&id=5d1cbed7"
import script from "./ManagedListCard.vue?vue&type=script&lang=js"
export * from "./ManagedListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports